export default __webpack_public_path__ + "static/media/1729.2ca42dbc.png";